import { VisuallyHidden } from "@radix-ui/react-visually-hidden";
import { useTranslation } from "react-i18next";

import { useUnsavedChanges } from "~/providers/unsaved-changes-provider";
import { usePriceStore } from "~/stores/use-price-store";
import { Button } from "../ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "../ui/dialog";
import { ScrollArea } from "../ui/scroll-area";
import PriceForm from "./price-form";

export default function PriceDialog() {
  const {
    priceDialogOpen,
    selectedPrice,
    setPriceDialogOpen,
    setSelectedPrice,
    isLoading,
  } = usePriceStore();

  const { checkUnsavedChanges } = useUnsavedChanges();

  const { t } = useTranslation("common");

  const handleDialog = (open: boolean, force?: boolean) => {
    if (open === false) {
      if (force !== true) {
        const result = checkUnsavedChanges();
        if (result === true) return;
      }
      setSelectedPrice(undefined);
    }
    setPriceDialogOpen(open);
  };

  return (
    <Dialog open={priceDialogOpen} onOpenChange={handleDialog}>
      <DialogContent className="max-w-xl w-full">
        <DialogHeader>
          <DialogTitle>{t("Price.price")}</DialogTitle>
          <VisuallyHidden>
            <DialogDescription></DialogDescription>
          </VisuallyHidden>
        </DialogHeader>
        <ScrollArea className="max-h-[80vh] p-4">
          <PriceForm
            price={selectedPrice}
            onClose={(force) => handleDialog(false, force)}
          />
        </ScrollArea>
        <DialogFooter>
          <Button
            disabled={isLoading}
            type="submit"
            variant="success"
            form="price-form"
            className="w-full"
          >
            {selectedPrice ? t("update") : t("create")}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
